module.exports = __webpack_public_path__ + "static/img/decor.d2bdd3a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/decor.svg
// module id = 55
// module chunks = 0